package tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_status_bottomsheet

data class QueueUser(
    val name: String,
    val isYou: Boolean = false,
    val waitRange: String? = null
)
